import React from 'react';

import { ErrorPanel } from '../error-panel';
import { LoadingIndicator } from '../loading-indicator';
import { TableProps } from './table.component';

type TableStateProps = {
  data: any[];
  hasError: boolean;
  showFetchingOverlay?: boolean;
} & Pick<
  TableProps,
  'isLoading' | 'loadingState' | 'errorState' | 'error' | 'emptyState'
>;

const TableStateWrapper: React.FC = ({ children }) => (
  <div className="px-6 py-20 flex justify-center items-center">{children}</div>
);

export const TableState: React.FC<TableStateProps> = ({
  isLoading,
  loadingState,
  showFetchingOverlay,
  hasError,
  errorState,
  error,
  data,
  emptyState,
}) => {
  if (isLoading) {
    return (
      <TableStateWrapper>
        {loadingState ?? <LoadingIndicator />}
      </TableStateWrapper>
    );
  }

  if (showFetchingOverlay) {
    return (
      <div className="absolute inset-0 pt-10 flex items-center justify-center">
        <LoadingIndicator showMessage={false} />
      </div>
    );
  }

  if (hasError) {
    return (
      <TableStateWrapper>
        {errorState ?? <ErrorPanel error={error} />}
      </TableStateWrapper>
    );
  }

  if (data && data.length < 1) {
    return (
      <TableStateWrapper>
        {emptyState ?? (
          <div className="text-lg font-medium">No results found.</div>
        )}
      </TableStateWrapper>
    );
  }

  return null;
};
